export enum MENUPLANNERITEMTYPE {
	MENU = 'Menu',
	RECIPE = 'Recipe',
}
